import React from 'react';

// Cropped versions of the supplied CLAX logo asset (generated from the original file, not recreated).
const SRC = { dark: '/clax-logo-dark-crop.png', light: '/clax-logo-light-crop.png' };
const RATIO = 1108 / 348;

export default function Logo({ height = 40, variant = 'light', className = '' }) {
  return (
    <img
      src={SRC[variant] || SRC.light}
      alt="CLAX"
      draggable={false}
      className={`inline-block select-none ${className}`}
      style={{ height, width: height * RATIO, maxWidth: 'none' }}
    />
  );
}
